import Login from './Login/Login';

export const LandingPage = () => {
  return <Login />;
};
